import React, { ReactNode } from 'react';

interface FooterProps {
	children: ReactNode;
}

export const Footer = ({ children }: FooterProps) => {
	return (
		<footer className="w-full flex p-2 flex-col justify-center items-center gap-3 border-t border-tablz-med-gray-4 bg-tablz-dark-gray-2">{children}</footer>
	);
};
